export default __webpack_public_path__ + "25a182f265f8cc2d78a815547f118a3c.svg";